// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "canvas{image-rendering:-webkit-crisp-edges;image-rendering:pixelated;image-rendering:crisp-edges}.t-vue-lspan{font-variant-numeric:tabular-nums;font-size:.95em;color:#7c7c7c!important;margin-left:.1em;margin-right:.2em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
